const Ls8Hospital = () => {
    return (
        <div className="container-fluid bg--main ps-0 ps-sm-0 ps-md-0 ps-lg-3">
            <div className="row d-flex p-0">
                <div className="col-sm-12 col-md-12 col-lg-9 col-xl-7">
                    <h1 className='titulo--lesson--color--1'>Mientras mi <span className='titulo--lesson--color--2'>beb&eacute; est&aacute; en el hospital</span></h1>

                    <div className='container p-4'>
                        <p className='texto--parrafo'>Debido a la fragilidad de los beb&eacute;s prematuros, la mayor&iacute;a de ellos requieren ser hospitalizados en la UCI neonatal durante un tiempo. Tenga en cuenta las siguientes recomendaciones:</p>
                    </div>

                    <div className='container px-4'>
                        <div className='row d-flex align-items-center bg-white rounded py-3'>
                            <div className='col-3 col-ms-4 col-md-4 col-lg-4 col-xl-2 m-0'>
                                <img src="./img/Ls8Corazon.png" className='ps-lg-2' />
                            </div>
                            <div className='col-9 col-ms-8 col-md-8 col-lg-8 col-xl-10'>
                                <p className='texto--parrafo fw-bold ps-4 my-0'>Antes de entrar a la unidad neonatal, recuerde siempre lavarse las manos cuidadosa y completamente. <br /><br />
                                    Su m&eacute;dico/a se debe lavar las manos antes de examinar a su beb&eacute;. No dude en recordarle de hacerlo. <br /> <br />
                                    Cuando usted ingrese a la unidad neonatal por primera vez, es probable que se sorprenda al ver m&aacute;quinas, tubos cerca de su beb&eacute; y cables en la piel del beb&eacute;. No dude en pedir al profesional en enfermer&iacute;a que le explique el prop&oacute;sito de cada uno de ellos.</p>
                            </div>
                        </div>
                    </div>

                    <div className='container py-5'>
                        <div className='row d-flex align-items-center'>
                            <div className='col-3 col-ms-4 col-md-4 col-lg-4 col-xl-2'>
                                <img src="./img/Ls8Face.png" className='ps-lg-4' />
                            </div>
                            <div className='col-9 col-ms-8 col-md-8 col-lg-8 col-xl-10'>
                                <p className='texto--parrafo ps-lg-4 ps-xl-4'><span className="texto--span">Inicialmente, usted podr&iacute;a sentir que no es apropiado tocar al beb&eacute; por
                                    su aspecto fr&aacute;gil, pero deber&iacute;a hacerlo tan pronto como sea posible.
                                    Su tacto ayuda a su beb&eacute; a vincularse o conectarse con usted, lo cual es
                                    muy importante.</span></p>
                            </div>
                        </div>
                    </div>

                    <div className='container p-4'>
                        <p className='texto--parrafo'>En algunos hospitales se permite la visita de familiares del beb&eacute;, pero usted debe solicitar a la gente que se aleje si tiene una enfermedad o un resfriado, ya que podr&iacute;a contagiar a otros en el hospital.</p>
                    </div>

                    <div className='container p-4'>
                        <p className='texto--link'>UCI: unidad de cuidados intensivos. <br />
                            Adaptado de <a className='texto--link' target='_blank' href='http://www.nhs.uk/conditions/pregnancy-and-baby/pages/baby-special-intensive-care.aspx'>http://www.nhs.uk/conditions/pregnancy-and-baby/pages/baby-special-intensive-care.aspx</a> <br/> <a className='texto--link' target='_blank' href='http://mayoclinic.org/healthy-lifestyle/infant-and-toddler-health/in-depth/premature-baby/art-20046286'>http://mayoclinic.org/healthy-lifestyle/infant-and-toddler-health/in-depth/premature-baby/art-20046286</a></p>
                    </div>

                    <div className='container p-4'>
                        <p className='texto--parrafo'>Es posible que inicialmente su beb&eacute; no est&eacute; en capacidad de succionar ni deglutir, por lo que ser&aacute; necesario administrarle leche materna por otras v&iacute;as (como tubos o sondas) mientras desarrolla esta capacidad.</p>
                    </div>

                    <div className='container py-3'>
                        <div className='row d-flex align-items-center'>
                            <div className='col-3 col-ms-4 col-md-4 col-lg-4 col-xl-2'>
                                <img src="./img/Ls8Succionar.png" className='' />
                            </div>
                            <div className='col-9 col-ms-8 col-md-8 col-lg-8 col-xl-10'>
                                <p className='texto--span ps-lg-4 ps-xl-4'><span className="texto--span">En caso de que su beb&eacute; no pueda succionar, es importante que extraiga la leche materna con un dispositivo dise&ntilde;ado para tal fin, al menos de 6 a 8 veces al d&iacute;a.</span></p>
                            </div>
                        </div>
                    </div>

                    <div className='container p-4'>
                        <p className='texto--link'>
                            Adaptado de: <a className='texto--link' target='_blank' href=' https://www.healthychildren.org/English/ages-stages/baby/breastfeeding/Pages/Providing-Breastmilk-for-Premature-and-Ill-Newborns.aspx'> https://www.healthychildren.org/English/ages-stages/baby/breastfeeding/Pages/Providing-Breastmilk-for-Premature-and-Ill-Newborns.aspx</a></p>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Ls8Hospital;